import {
  SHOP_TAXONOMY_SKIP_SEGMENT,
  taxonomyAttributeToFacetKey,
} from 'src/adapters/pageURLToStore/shop/constants';
import type { ShopTaxonomyLevels } from 'src/adapters/pageURLToStore/shop/shopTaxonomyPath';
import type { Facet } from 'src/redux/productsQuery/types/Facet';

/**
 * Reconstructs the `/shop` path taxonomy slots from active facet options. Levels with no active
 * options are filled with the skip placeholder unless they're after the last non-empty level,
 * in which case they're trimmed (matching `parseShopPath`'s trailing-`all` stripping).
 */
export const deriveShopTaxonomyLevelsFromFacets = (
  facets: Facet[],
  taxonomyAttributes: string[] | undefined,
): ShopTaxonomyLevels => {
  if (!taxonomyAttributes?.length) {
    return [];
  }

  const facetByKey = new Map(facets.map((facet) => [facet.key, facet]));

  const slots: string[][] = taxonomyAttributes.map((attribute) => {
    const facet = facetByKey.get(taxonomyAttributeToFacetKey(attribute));
    if (!facet) {
      return [];
    }
    return facet.options.filter((option) => option.active).map((option) => option.value);
  });

  while (slots.length > 0 && slots[slots.length - 1]!.length === 0) {
    slots.pop();
  }

  return slots.map((slot) => (slot.length === 0 ? [SHOP_TAXONOMY_SKIP_SEGMENT] : slot));
};
